import type { DoujinWork } from "@/mocks/doujinshi";

interface WorkCardProps {
  work: DoujinWork;
}

const ipNames: Record<string, string> = {
  naruto: "火影忍者",
  onepiece: "海贼王",
  jjk: "咒术回战",
  kimetsu: "鬼灭之刃",
  haikyu: "排球少年",
};

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg bg-background-800/70 ring-1 ring-background-200/60 transition-all duration-300 hover:-translate-y-1 hover:ring-accent-400/50">
      <a href="#featured" className="relative block overflow-hidden">
        <div className="relative h-60 w-full overflow-hidden md:h-64">
          <img
            src={work.cover}
            alt={`${work.title} - ${ipNames[work.ip]}同人漫画封面`}
            title={`${work.title} 同人漫画`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-900/90 via-transparent to-transparent"></div>
          <span className="absolute left-3 top-3 inline-flex items-center rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-background-50">
            {ipNames[work.ip]}
          </span>
          <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-md bg-background-900/70 px-2 py-1 text-xs font-medium text-foreground-200 backdrop-blur">
            <i className="ri-book-open-line text-xs"></i>
            {work.chapters}话
          </span>
          <span className="absolute bottom-3 left-3 rounded-md bg-background-950/70 px-2 py-1 text-xs font-medium text-foreground-300 backdrop-blur">
            {work.status}
          </span>
        </div>
      </a>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950">
          <a href="#featured" className="hover:text-accent-400">
            {work.title}
          </a>
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          {work.tag.map((t) => (
            <span
              key={t}
              className="rounded-full bg-secondary-500/15 px-2 py-0.5 text-xs text-secondary-300"
            >
              {t}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {work.intro}
        </p>
        <div className="mt-4 flex items-center justify-between border-t border-background-200/60 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-sm"></i>
            {work.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-3-line text-sm"></i>
            {work.likes}
          </span>
          <span className="text-foreground-400">更新 {work.updated}</span>
        </div>
      </div>
    </article>
  );
}